import React, {useEffect, useState} from 'react'
import SuccessModal from "../../CustomModal/Success";
import FailedModal from "../../CustomModal/Failed";
import Header from "../../layout/header";
import BottomMenu from "../../layout/bottomMenu";
import Loader from "../../../Loader/Loader";
import useLatLng from "../../../hooks/uselatlng/uselatlng";
import "../../Dashboard/Dashboard.css";
import "../../Dashboard/Sidebar";
import DashboardMenu from "../../layout/dashboardMenu";
import {toast} from "react-toastify";
import {accountById} from "../../../service/Valet/action";

const ValetOpportunities = ({
                                 dropdownData,
                                 dropdownValue = [],
                                 save,
                                 saveDetails = [],
                                 match,
                                 history,
                                accountDetailsByIdData,
                                accountById
                             }) => {

    const [isLoading, setIsLoading] = useState(false)
    const [inputList, setInputList] = useState([{}])
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = React.useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [opportunityTypes, setOpportunityTypes] = useState([])
    const [opportunityTypeId, setOpportunityTypeId] = useState('')
    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        lat: 0,
        lng: 0,
    });
    const islatlng = useLatLng();
    const [isAllow, setIsAllow] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState('')
    const [inputSiteList, setInputSiteList] = useState([{
        solution_type: 'null',
        business_model: '',
        source: '',
        valet_solution_present:'',
        valet_solution_present_yes:'',
        other_source:'',
        monthly_user_projected: '',
        revenue_projected: '',
        operation_timing: '',
        daily_vehicle_football: '',
        daily_expected_pickup: '',
        dedicated_manpower_available: '',
        manpower_last_shift_time: '',
        smartphone_available_manpower: '',
        is_gmc_enabled: '',
        payment_flow_required: '',
        is_online_payment_enabled: '',
        client_aligned_duty_auto_assignment_flow: '',
        client_aligned_duty_photo_click: '',
        client_aligned_deprecate_physical_tag: '',
        valet_driver_name: '',
        valet_driver_phone_no: '',
        valet_supervisor_name: '',
        valet_supervisor_phone_no: '',
        parking_zone_slot_capacity: '',
    }]);

    const handleInput = (val, index) => {
        const list = [...inputSiteList]
        list[0][index] = val;
        setInputSiteList(list);
    }

    useEffect( () => {
        (async () => {
            setIsLoading(true);
            await dropdownData('is_valet');
            await accountById(match?.params?.id);
            setIsLoading(false);
        })();
    }, [])

    useEffect(() => {
        if (dropdownValue?.opportunity_types !== undefined) {
            setOpportunityTypes(dropdownValue?.opportunity_types)
        }

    }, [dropdownValue])

    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: 'Delhi6',
                lat: Number(islatlng?.lat),
                lng: Number(islatlng?.lng),
            });
        }
    }, [islatlng]);

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (saveDetails?.status === 200) {
            setIsSuccessModalOpen(true)
            setRedirectUrl('valet-opportunity-list/'+match?.params?.id)
        } else if (saveDetails?.status !== undefined && saveDetails?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
        }
    }, [saveDetails])



    /**
     * @param e
     * @returns {Promise<void>}
     */
    const handleSubmit = async (e) => {
        e.preventDefault()
        inputList[0]['latitude'] = islatlng?.lat
        inputList[0]['longitude'] = islatlng?.lng
        if(inputList[0]['longitude'] == null || inputList[0]['latitude'] == null){
            toast.error('Please enable your location');
            return false
        }

        inputList[0]['account_id'] = match?.params?.id
        inputList[0]['opportunity_type_id'] = opportunityTypeId
        inputList[0]['not_new_activity'] = true
        // not in use, have used api to save opportunity for apartment , corporate, valet and supply
        inputList[0]['details'] = ["testing"];
        inputList[0]['is_valet'] = true;
        inputSiteList[0]['valet_solution_present'] = {valet_solution_present:inputSiteList[0]['valet_solution_present'], valet_solution_present_yes: inputSiteList[0]['valet_solution_present_yes']}
        const request = Object.assign({}, inputList[0], inputSiteList[0]);
        // console.log("inputList", request);
        // return ;
        setIsLoading(true)
        await save(request)
        setIsLoading(false)
    }

    useEffect(() => {
        if (accountDetailsByIdData?.data !== undefined) {
            handleInput(accountDetailsByIdData?.data?.solution_type, 'solution_type')
            handleInput(accountDetailsByIdData?.data?.parking_zone_slot_capacity, 'parking_zone_slot_capacity')
            handleInput(accountDetailsByIdData?.data?.valet_supervisor_phone_no, 'valet_supervisor_phone_no')
            handleInput(accountDetailsByIdData?.data?.valet_supervisor_name, 'valet_supervisor_name')
            handleInput(accountDetailsByIdData?.data?.valet_driver_phone_no, 'valet_driver_phone_no')
            handleInput(accountDetailsByIdData?.data?.valet_driver_name, 'valet_driver_name')
            handleInput(accountDetailsByIdData?.data?.client_aligned_duty_photo_click, 'client_aligned_duty_photo_click')
            handleInput(accountDetailsByIdData?.data?.client_aligned_duty_auto_assignment_flow, 'client_aligned_duty_auto_assignment_flow')
            handleInput(accountDetailsByIdData?.data?.payment_flow_required, 'payment_flow_required')
            handleInput(accountDetailsByIdData?.data?.is_gmc_enabled, 'is_gmc_enabled')
            handleInput(accountDetailsByIdData?.data?.dedicated_manpower_available, 'dedicated_manpower_available')
            handleInput(accountDetailsByIdData?.data?.daily_expected_pickup, 'daily_expected_pickup')
            handleInput(accountDetailsByIdData?.data?.daily_vehicle_football, 'daily_vehicle_football')
            handleInput(accountDetailsByIdData?.data?.operation_timing, 'operation_timing')
            handleInput(accountDetailsByIdData?.data?.revenue_projected, 'revenue_projected')
            handleInput(accountDetailsByIdData?.data?.source, 'source')
            handleInput(accountDetailsByIdData?.data?.business_model, 'business_model')
            handleInput(accountDetailsByIdData?.data?.solution_type, 'solution_type')
            handleInput(accountDetailsByIdData?.data?.monthly_user_projected, 'monthly_user_projected')
            handleInput(accountDetailsByIdData?.data?.manpower_last_shift_time, 'manpower_last_shift_time')
            handleInput(accountDetailsByIdData?.data?.smartphone_available_manpower, 'smartphone_available_manpower')
            handleInput(accountDetailsByIdData?.data?.is_online_payment_enabled, 'is_online_payment_enabled')
            handleInput(accountDetailsByIdData?.data?.client_aligned_deprecate_physical_tag, 'client_aligned_deprecate_physical_tag')
            handleInput(accountDetailsByIdData?.data?.valet_solution_present?.valet_solution_present, 'valet_solution_present')
            handleInput(accountDetailsByIdData?.data?.valet_solution_present?.valet_solution_present_yes, 'valet_solution_present_yes')
            handleInput(accountDetailsByIdData?.data?.name_of_referrer, 'other_source')

        }
    }, [accountDetailsByIdData])

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={saveDetails?.message}
                url={redirectUrl}
            />


            <FailedModal
                isOpen={isFailedModalOpen}
                msg={saveDetails?.message}
                countToOpenModal={countToOpenModal}
            />
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"Add Opportunity"}
                            history={history}
                        />
                        {/*BODY*/}
                        <div className="container-fluid">
                            {/*Heading*/}
                            {/* <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                <h1 className="h3 mb-0 text-black-100">Add Opportunities</h1>
                            </div> */}
                            <form onSubmit={(e) => handleSubmit(e)}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="mb-0 bg-white">
                                            {/* <div className="card-header bg-lightGreen-active">
                                                Opportunities
                                            </div> */}
                                            <div className="card-body">
                                                <div className="user">
                                                    <div className="form-group row">
                                                        <div className="col-sm-6 float-field uu-select">
                                                            <select className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        setOpportunityTypeId(e.target.value)
                                                                    }} required>
                                                                <option value="">Select Opportunity Type</option>
                                                                {opportunityTypes && opportunityTypes.map((val) => {
                                                                    return (
                                                                        <option
                                                                            value={val?.id}>{val.name}</option>
                                                                    )
                                                                })}

                                                            </select>
                                                            <label className="large-label float-lb">
                                                                Opportunity Type
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    <h1 className="h3 mb-0 text-black-100">Site Details</h1>
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            {/*<div className="col-md-6 float-field ">*/}
                                                            {/*    <input type="text"*/}
                                                            {/*           className="form-control form-control-user"*/}
                                                            {/*           placeholder=" "*/}
                                                            {/*           onChange={(e) => {*/}
                                                            {/*               handleInput(e.target.value, 'client_name')*/}
                                                            {/*           }}*/}
                                                            {/*           required*/}
                                                            {/*           value={inputList[0]?.client_name}*/}
                                                            {/*    />*/}

                                                            {/*    <label className="large-label float-lb">*/}
                                                            {/*        Site Name <i*/}
                                                            {/*        className="bi bi-asterisk astrick-icon"></i>*/}
                                                            {/*    </label>*/}
                                                            {/*</div>*/}

                                                            {/*<div className="col-md-6 float-field">*/}
                                                            {/*    <select className="form-control"*/}
                                                            {/*            onChange={(e) => {*/}
                                                            {/*                handleInput(e.target.value, 'solution_type')*/}
                                                            {/*            }} required>*/}
                                                            {/*        <option value="">Select Solution Type</option>*/}
                                                            {/*        {inputList[0].solution_type === "Manpower+Saas" ?*/}
                                                            {/*            <>*/}
                                                            {/*                <option value="Manpower+Saas" selected>Manpower + Saas*/}
                                                            {/*                </option>*/}
                                                            {/*                <option value="Saas">Saas</option>*/}
                                                            {/*            </> :*/}
                                                            {/*            inputList[0].solution_type === "Saas" ?*/}
                                                            {/*                <>*/}
                                                            {/*                    <option value="Manpower">Manpower</option>*/}
                                                            {/*                    <option value="Saas" selected>Saas</option>*/}
                                                            {/*                </> :*/}
                                                            {/*                <>*/}
                                                            {/*                    <option value="Manpower+Saas">Manpower + Saas</option>*/}
                                                            {/*                    <option value="Saas">Saas</option>*/}
                                                            {/*                </>*/}
                                                            {/*        }*/}

                                                            {/*    </select>*/}

                                                            {/*    <label className="large-label float-lb">*/}
                                                            {/*        Solution Type <i className="bi bi-asterisk astrick-icon"></i>*/}
                                                            {/*    </label>*/}
                                                            {/*</div>*/}
                                                            <div className="col-md-6 float-field">
                                                                <select className="form-control"
                                                                        onChange={(e) => {
                                                                            handleInput(e.target.value, 'business_model')
                                                                        }} >
                                                                    <option value="">Select Business Model</option>
                                                                    <option value="Revenue" selected={inputSiteList[0].business_model === "Revenue"}>Revenue</option>
                                                                    <option value="Cost" selected={inputSiteList[0].business_model === "Cost"}>Cost</option>

                                                                </select>

                                                                <label className="large-label float-lb">
                                                                Business Model
                                                                    {/*<i*/}
                                                                    {/*className="bi bi-asterisk astrick-icon"></i>*/}
                                                                </label>
                                                            </div>
                                                            <div className="col-md-6 float-field">
                                                                <select className="form-control"
                                                                        onChange={(e) => {
                                                                            handleInput(e.target.value, 'valet_solution_present')
                                                                        }} >
                                                                    <option value="">Select Valet Solution Present
                                                                    </option>
                                                                    <option value="Yes" selected={inputSiteList[0].valet_solution_present === "Yes"}>Yes</option>
                                                                    <option value="No" selected={inputSiteList[0].valet_solution_present === "No"}>No</option>

                                                                </select>

                                                                <label className="large-label float-lb">
                                                                Valet Solution Present
                                                                    {/*<i*/}
                                                                    {/*className="bi bi-asterisk astrick-icon"></i>*/}
                                                                </label>
                                                            </div>
                                                            {inputSiteList[0].valet_solution_present === 'Yes' &&
                                                                <div className="col-md-6 float-field">
                                                                    <input type="text"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           onChange={(e) => {
                                                                               handleInput(e.target.value, 'valet_solution_present_yes')
                                                                           }}
                                                                           value={inputSiteList[0]?.valet_solution_present_yes}
                                                                          required={true}
                                                                    />
                                                                    <label className="large-label float-lb">
                                                                        Solution Present
                                                                        <i
                                                                        className="bi bi-asterisk astrick-icon"></i>
                                                                    </label>
                                                                </div>
                                                            }
                                                            <div className="col-md-6 float-field">
                                                                <select className="form-control"
                                                                        onChange={(e) => {
                                                                            handleInput(e.target.value, 'source')
                                                                        }} >
                                                                    <option value="">Select Source</option>
                                                                    <option
                                                                        value="Referral - Client" selected={inputSiteList[0].source === "Enquiry - Client"}>Referral
                                                                        - Client
                                                                    </option>
                                                                    <option
                                                                        value="Referral - Team (Internal)" selected={inputSiteList[0].source === "Enquiry - Team (Internal)"}>Referral
                                                                        - Team (Internal)
                                                                    </option>
                                                                    <option
                                                                        value="Enquiry - Existing Site" selected={inputSiteList[0].source === "Enquiry - Existing Site"}>Enquiry
                                                                        - Existing Site
                                                                    </option>
                                                                    <option
                                                                        value="Enquiry - Inbound" selected={inputSiteList[0].source === "Enquiry - Inbound"}>Enquiry
                                                                        - Inbound
                                                                    </option>
                                                                    <option
                                                                        value="Enquiry - Outbound" selected={inputSiteList[0].source === "Enquiry - Outbound"}>Enquiry
                                                                        - Outbound
                                                                    </option>
                                                                    <option
                                                                        value="Others" selected={inputSiteList[0].source === "Others"}>Others
                                                                    </option>
                                                                </select>
                                                                <label className="large-label float-lb">
                                                                    Source
                                                                    {/*<i*/}
                                                                    {/*className="bi bi-asterisk astrick-icon"></i>*/}
                                                                </label>
                                                            </div>
                                                            {inputSiteList[0].source === "Others" &&
                                                                <div className="col-md-6 float-field">
                                                                    <input type="text"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           onChange={(e) => {
                                                                               handleInput(e.target.value, 'other_source')
                                                                           }}
                                                                           value={inputSiteList[0]?.other_source}
                                                                           required={true}

                                                                    />
                                                                    <label className="large-label float-lb">
                                                                        Source
                                                                        <i
                                                                        className="bi bi-asterisk astrick-icon"></i>
                                                                    </label>
                                                                </div>
                                                            }
                                                            <div className="col-md-6 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput(e.target.value, 'monthly_user_projected')
                                                                       }}
                                                                       value={inputSiteList[0]?.monthly_user_projected}

                                                                />
                                                                <label className="large-label float-lb">
                                                                    Daily User Projected
                                                                    {/*<i*/}
                                                                    {/*className="bi bi-asterisk astrick-icon"></i>*/}
                                                                </label>
                                                            </div>
                                                            <div className="col-md-6 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput(e.target.value, 'revenue_projected')
                                                                       }}
                                                                       value={inputSiteList[0]?.revenue_projected}
                                                                       // required
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Monthly Revenue Projected
                                                                    {/*<i*/}
                                                                    {/*className="bi bi-asterisk astrick-icon"></i>*/}
                                                                </label>
                                                            </div>
                                                            <div className="col-md-6 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput(e.target.value, 'operation_timing')
                                                                       }}
                                                                       value={inputSiteList[0]?.operation_timing}
                                                                       // required
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Operation Timing
                                                                    {/*<i*/}
                                                                    {/*className="bi bi-asterisk astrick-icon"></i>*/}
                                                                </label>
                                                            </div>
                                                            <div className="col-md-6 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput(e.target.value, 'daily_vehicle_football')
                                                                       }}
                                                                       value={inputSiteList[0]?.daily_vehicle_football}
                                                                       // required
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Daily Vehicle Footfall
                                                                    {/*<i*/}
                                                                    {/*className="bi bi-asterisk astrick-icon"></i>*/}
                                                                </label>
                                                            </div>
                                                            <div className="col-md-6 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput(e.target.value, 'daily_expected_pickup')
                                                                       }}
                                                                       value={inputSiteList[0]?.daily_expected_pickup}
                                                                       // required
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Daily Expected Pickup
                                                                    {/*<i*/}
                                                                    {/*className="bi bi-asterisk astrick-icon"></i>*/}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-2">
                                    <button className="btn btn-primary btn-user btn-block submit-btn">
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <BottomMenu/>
            </div>
        </>
    )
}

export default ValetOpportunities